<template>
  <div>
    <div class="white-section">
      <div class="d-flex justify-content-end" style="align-items: center">
        <div style="margin-left: auto" class="page-title">
          <b-breadcrumb-item
            v-for="item in breadcrumb"
            :key="item.text"
            :active="item.active"
            class="bread-crumb"
          >
            <div v-if="item.active">
              {{ item.translate ? $t(`navigation.${item.text}`) : item.text }}
            </div>
          </b-breadcrumb-item>
        </div>
        <div
          class="custom-search mb-0 d-flex"
          style="box-shadow: none; padding: 10px 0"
        >
          <!-- <b-form-group>
            <div class="d-flex align-items-center">
              <label class="mr-1">{{ $t("general.search") }}</label>
              <b-form-input
                v-model="searchTerm"
                :placeholder="$t('general.search')"
                type="text"
                class="d-inline-block"
              />
            </div>
          </b-form-group> -->
        </div>
      </div>
      <v-app>
        <b-form @submit.prevent class="mt-4">
          <div class="white-section pt-3 mb-2">
            <section class="box-has-title mb-3">
              <b-row>
                <b-col lg="4" md="4" sm="6" xl="3" class="message">
                  <b-form-group
                    :label="$t('navigation.doctorsList')"
                    label-for="navigation-doctorsList"
                  >
                  <!-- <my-v-select
                    id="navigation-doctorsList"
                    v-model="doctor"
                    :options="doctorOptions.length ? doctorOptions : []"
                    :translate="false"
                    :searchable="true"
                  /> -->
                  <v-select
                      id="user-doctorList"
                      :items="doctorOptions"
                      v-model="doctor"
                      item-text="title"
                      item-value="_id"
                      filled
                      class="selectCountri"
                    ></v-select>
                  </b-form-group>
                </b-col>

                <b-col lg="2" md="4" sm="6" xl="3">
                  <b-form-group
                    :label="$t('user.messageType')"
                    label-for="user-messageType"
                    :invalid-feedback="
                      invalidFeedbackMessageType
                        ? $t(`validation.${invalidFeedbackMessageType}`, {
                            field: $t('user.messageType'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.messageType.required }"
                    :state="
                      $v.messageType.$dirty
                        ? !$v.messageType.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <b-form-select
                      v-model="messageType"
                      :options="allMessageTypes"
                      text-field="fa"
                      value-field="en"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled
                          >انتخاب کنید</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col lg="4" md="4" sm="6" xl="2">
                  <b-form-group
                    :label="$t('user.messageTime')"
                    label-for="user-messageTime"
                    :invalid-feedback="
                      invalidFeedbackMessageTime
                        ? $t(`validation.${invalidFeedbackMessageTime}`, {
                            field: $t('user.messageTime'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.messageTime.required }"
                    :state="
                      $v.messageTime.$dirty
                        ? !$v.messageTime.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <b-form-radio-group
                      id="user-messageTime"
                      ref="messageTime"
                      v-model="messageTime"
                      :options="allMessageTime"
                      text-field="fa"
                      value-field="en"
                      :state="
                        $v.messageTime.$dirty
                          ? !$v.messageTime.$invalid === false
                            ? false
                            : null
                          : null
                      "
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>

                <b-col
                  lg="2"
                  md="4"
                  sm="6"
                  xl="2"
                  v-if="messageTime === 'regulatory'"
                >
                  <b-form-group
                    :label="$t('user.messageTimeValue')"
                    label-for="user-messageTimeValue"
                    :invalid-feedback="
                      invalidFeedbackMessageValue
                        ? $t(`validation.${invalidFeedbackMessageValue}`, {
                            field: $t('user.messageTimeValue'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.messageTimeValue.required }"
                    :state="
                      $v.messageTimeValue.$dirty
                        ? !$v.messageTimeValue.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <input
                      v-model="messageTimeValue"
                      type="text"
                      class="form-control"
                      id="user-messageTimeValue"
                      :state="
                        $v.messageTimeValue.$dirty
                          ? !$v.messageTimeValue.$invalid === false
                            ? false
                            : null
                          : null
                      "
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  lg="2"
                  md="4"
                  sm="6"
                  xl="2"
                  v-if="messageTime === 'regulatory'"
                >
                  <b-form-group
                    :label="$t('user.messageTimeUnit')"
                    label-for="user-messageTimeUnit"
                    :invalid-feedback="
                      invalidFeedbackMessageUnit
                        ? $t(`validation.${invalidFeedbackMessageUnit}`, {
                            field: $t('user.messageTimeUnit'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.messageTimeUnit.required }"
                    :state="
                      $v.messageTimeUnit.$dirty
                        ? !$v.messageTimeUnit.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <b-form-select
                      v-model="messageTimeUnit"
                      :options="allMessageTimeUnit"
                      text-field="fa"
                      value-field="en"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled
                          >انتخاب کنید</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col lg="2" md="4" sm="6" xl="2">
                  <b-form-group
                    :label="$t('user.messageTimeState')"
                    label-for="user-messageTimeState"
                    :invalid-feedback="
                      invalidFeedbackMessageState
                        ? $t(`validation.${invalidFeedbackMessageState}`, {
                            field: $t('user.messageTimeState'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.messageTimeState.required }"
                    :state="
                      $v.messageTimeState.$dirty
                        ? !$v.messageTimeState.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <b-form-radio-group
                      id="user-messageTimeState"
                      ref="messageTimeState"
                      v-model="messageTimeState"
                      :options="allMessageTimeState"
                      text-field="fa"
                      value-field="en"
                      :state="
                        $v.messageTimeState.$dirty
                          ? !$v.messageTimeState.$invalid === false
                            ? false
                            : null
                          : null
                      "
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>

                <b-col
                  lg="4"
                  md="4"
                  sm="6"
                  xl="4"
                  class="v-app-select chips"
                  v-if="messageType === 'adminTotalPatientStatTomorrowTurn'"
                >
                  <b-form-group
                    :label="$t('user.mobiles')"
                    label-for="mobiles"
                    :invalid-feedback="
                      invalidFeedbackMessageMobiles
                        ? $t(`validation.${invalidFeedbackMessageMobiles}`, {
                            field: $t('user.mobiles'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.mobiles.required }"
                    :state="
                      $v.mobiles.$dirty
                        ? !$v.mobiles.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <v-combobox v-model="mobiles" chips clearable multiple>
                      <template v-slot:selection="{ attrs, item, select }">
                        <v-chip
                          v-bind="attrs"
                          close
                          @click="select"
                          @click:close="remove(item)"
                        >
                          <div>
                            <span>{{ item }}</span>
                          </div>
                        </v-chip>
                      </template>
                    </v-combobox>
                    <div class="hint">
                      بعد از وارد کردن هر شماره کلید اینتر را بفشارید
                    </div>
                  </b-form-group>
                </b-col>

                <b-col lg="12">
                  <b-form-group
                    :label="$t('user.message')"
                    label-for="user-message"
                    :invalid-feedback="
                      invalidFeedbackMessage
                        ? $t(`validation.${invalidFeedbackMessage}`, {
                            field: $t('user.message'),
                          })
                        : ''
                    "
                    :class="{ 'required-group': !$v.content.required }"
                    :state="
                      $v.content.$dirty
                        ? !$v.content.$invalid === false
                          ? false
                          : null
                        : null
                    "
                  >
                    <textarea
                      name=""
                      v-model="content"
                      id="user-message"
                      class="form-control"
                      style="min-height: 100px"
                      :state="
                        $v.content.$dirty
                          ? !$v.content.$invalid === false
                            ? false
                            : null
                          : null
                      "
                    ></textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </section>
          </div>
          <div class="white-section">
            <b-row>
              <!-- submit and reset -->
              <b-col class="text-right" md="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  size=""
                  type="submit"
                  variant="info"
                  @click="createMessage"
                >
                  {{ $t("general.submit") }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </v-app>
    </div>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import Vue from "vue";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import dateFormat from "@/mixins/dateFormat";
import flatPickr from "vue-flatpickr-component";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import filterRoles from "@/mixins/filterRoles";

import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BFormCheckbox,
  BCard,
  BCardHeader,
  BCardBody,
  BFormSelectOption,
  BForm,
  BFormRadioGroup,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormSelectOption,
    BButton,
    MyAbDatePicker,
    flatPickr,
    required,
    requiredIf,
    minLength,
    maxLength,
    sameAs,
    MyVSelect,
    BForm,
    BFormRadioGroup,
  },
  mixins: [dateFormat, filterRoles],
  data() {
    return {
      content: "",
      messageType: "",
      messageTime: "",
      messageTimeUnit: "",
      mobiles: [],
      users: [],
      doctorRoleId: "",
      doctor: "",
      messageTimeState: "",
      messageTimeValue: "",
      payload: {},
      allMessageTypes: [
        { en: "createTurn", fa: "پیامک بعد از ثبت نوبت" },
        { en: "reminderTurn", fa: "پیامک یادآوری نوبت" },
        { en: "moveTurn", fa: "پیامک جابه جایی نوبت" },
        { en: "removeTurn", fa: "پیامک حذف نوبت" },
        {
          en: "doctorPatientStatTurn",
          fa: "پیامک تعداد بیماران فردای هر دکتر",
        },
        {
          en: "adminTotalPatientStatTomorrowTurn",
          fa: "پیامک مدیریتی تعداد بیماران فردای مرکز",
        },
        { en: "patientTomorrowTakenTurn", fa: "بیماران نوبت گرفته فردا" },
        { en: "patientTodayVisited", fa: "بیماران ویزیت شده امروز" },
        {
          en: "doctorPatientTomorrowTakenTurn",
          fa: "دکترهای، بیماران نوبت گرفته فردا",
        },
        {
          en: "doctorPatientTodayVisited",
          fa: "دکترهای، بیماران ویزیت شده روز",
        },
      ],
      allMessageTime: [
        { en: "the_moment", fa: "در لحظه" },
        { en: "regulatory", fa: "زمان بندی" },
      ],
      allMessageTimeState: [
        { en: "before", fa: "قبل" },
        { en: "after", fa: "بعد" },
      ],
      allMessageTimeUnit: [
        { en: "minute", fa: "دقیقه" },
        { en: "hour", fa: "ساعت" },
        { en: "day", fa: "روز" },
      ],
      allMessages: [],
      pageLength: 20,
      page: 1,
      dir: false,
      searchTerm: "",
      doctorOptions: [],
    };
  },
  validations() {
    return {
      messageType: {
        required,
      },
      messageTime: {
        required,
      },
      messageTimeUnit: {
        required: requiredIf(() => {
          if (this.messageTime === "regulatory") {
            return true;
          } else {
            return false;
          }
        }),
      },
      messageTimeState: {
        required,
      },
      messageTimeValue: {
        required: requiredIf(() => {
          if (this.messageTime === "regulatory") {
            return true;
          } else {
            return false;
          }
        }),
      },
      mobiles: {
        required: requiredIf(() => {
          if (this.messageType === "adminTotalPatientStatTomorrowTurn") {
            return true;
          } else {
            return false;
          }
        }),
      },
      content: {
        required,
      },
    };
  },
  methods: {
    createMessage() {
      this.$v.$touch();
      
      if (!this.$v.$invalid) {
        if (
          this.doctor &&
          this.doctor.length > 0 &&
          this.messageTime !== "regulatory"
        ) {
          this.payload = {
            content: this.content,
            messageType: this.messageType,
            messageTime: this.messageTime,
            mobiles: this.mobiles,
            timeState: this.messageTimeState,
            doctorUserId: this.doctor,
          };
        } else if (
          this.doctor &&
          this.doctor.length > 0 &&
          this.messageTime === "regulatory"
        ) {
          this.payload = {
            doctorUserId: this.doctor,
            content: this.content,
            messageType: this.messageType,
            messageTime: this.messageTime,
            mobiles: this.mobiles,
            timeValue: this.messageTimeValue,
            timeUnit: this.messageTimeUnit,
            timeState: this.messageTimeState,
          };
        } else if (
          this.messageTime === "regulatory" &&
          this.doctor &&
          this.doctor.length === 0
        ) {
          this.payload = {
            content: this.content,
            messageType: this.messageType,
            messageTime: this.messageTime,
            mobiles: this.mobiles,
            timeValue: this.messageTimeValue,
            timeUnit: this.messageTimeUnit,
            timeState: this.messageTimeState,
          };
        } else {
          this.payload = {
            content: this.content,
            messageType: this.messageType,
            messageTime: this.messageTime,
            mobiles: this.mobiles,
            timeState: this.messageTimeState,
          };
        }
        this.$store
          .dispatch("message/addMessage", this.payload)
          .then((res) => {
            this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
              variant: "success",
              solid: true,
            });
            setTimeout(()=>{
              this.$router.push({
              name: "manageMessages",
            });
            },1000)
          })
          .catch((error) => {
            this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
              variant: "danger",
              solid: true,
            });
          });
      } else {
        const invalidFields = Object.keys(this.$v.$params).filter(
          (fieldName) => this.$v[fieldName].$invalid
        );
        this.$nextTick(() => {
          const el = document.querySelector(".is-invalid:first-of-type");
          
          el.scrollIntoView({ behavior: "instant", block: "center" });
          el.scrollIntoView();
          return;
        });
      }
    },
    searchUser() {
      const payload={
        page:1,
        roleTitle:"doctor",
        limit:100
      }
      this.$store.dispatch("user/searchUsers", payload).then((res) => {
        for (let i = 0; i < res.length; i++) {
        this.doctorOptions.push({
          title: res[i].firstName + " " + res[i].lastName,
          _id:res[i]._id
          
        });
  }
      });
    },
    remove(item) {
      this.mobiles.splice(this.mobiles.indexOf(item), 1);
    },
    editMessage(message) {
      this.$router.push({
        name: "editMessage",
        params: { id: message._id },
      });
    },
  },
  computed: {
    fullName() {
      return this.users.map((user) => `${user.firstName} ${user.lastName}`);
    },
    breadcrumb() {
      return typeof this.$route.meta.breadCrumb === "function"
        ? this.$route.meta.breadCrumb(this.$route)
        : this.$route.meta.breadCrumb;
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    statusVariant() {
      const statusColor = {
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
      };
      return (status) => statusColor[status];
    },

    invalidFeedbackMessageTime: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.messageTime.$dirty) return error;
        if (!this.$v.messageTime.required) error = "required";
        return error;
      },
    },
    invalidFeedbackMessageType: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.messageType.$dirty) return error;
        if (!this.$v.messageType.required) error = "required";
        return error;
      },
    },
    invalidFeedbackMessageUnit: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.messageTimeUnit.$dirty) return error;
        if (!this.$v.messageTimeUnit.required) error = "required";
        return error;
      },
    },
    invalidFeedbackMessageState: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.messageTimeState.$dirty) return error;
        if (!this.$v.messageTimeState.required) error = "required";
        return error;
      },
    },
    invalidFeedbackMessageValue: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.messageTimeValue.$dirty) return error;
        if (!this.$v.messageTimeValue.required) error = "required";
        return error;
      },
    },
    invalidFeedbackMessageMobiles: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.mobiles.$dirty) return error;
        if (!this.$v.mobiles.required) error = "required";
        return error;
      },
    },
    invalidFeedbackMessage: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.content.$dirty) return error;
        if (!this.$v.content.required) error = "required";
        return error;
      },
    },
  },
  created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "baseInformation", translate: true },
      { text: "addMessage", to: { name: "addMessage" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "addMessage", to: { name: "addMessage" }, translate: true },
    ]);
    
  },
  async mounted() {
    this.$store.dispatch("getRoles").then((res) => {
      if (res) {
        this.doctorRoleId = this.filterRoles("doctor");
        if (!this.roleFilter) this.roleFilter = this.doctorRoleId;
        this.searchUser();
      }
    });
  },
  watch: {
    messageType() {
      this.mobiles = [];
    },
    messageTime() {
      this.messageTimeValue = "";
      this.messageTimeUnit = "";
    },
  },
};
</script>

<style scoped>
.time-picker .flatpickr-input {
  height: 32px;
}
</style>
